
import { defineComponent } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

import store from "@/store";
import { IAuthModel } from "@/interfaces/modules/authetication/IAutheticationModel";

export default defineComponent({
  name: "LoginWithCarousel",
  components: { Swiper, SwiperSlide },
  setup() {
    const modules = [Autoplay, Pagination];
    const autoplay = { delay: 5000, disableOnInteraction: false };
    const pagination = { clickable: true };
    return { modules, autoplay, pagination };
  },
  data() {
    return {
      images: [
        "https://images.unsplash.com/photo-1588072432836-e10032774350?q=80&w=1080",
        "https://images.unsplash.com/photo-1558021212-51b6ecfa0db9?q=80&w=1080",
        "https://images.unsplash.com/photo-1529070538774-1843cb3265df?q=80&w=1080",
      ],
      form: {
        loading: false,
        record: {
          Email: "admin@liceosemillitas.com",
          Password: "95020210100",
        } as IAuthModel,
      },
    };
  },
  methods: {
    async handleSubmit(event: Event) {
      event.preventDefault();
      this.form.loading = true;
      try {
        await store.dispatch("auth/login", {
          Email: this.form.record.Email,
          Password: this.form.record.Password,
          vm: this,
        });
      } finally {
        this.form.loading = false;
      }
    },
  },
});
